import React, {useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {Navigate} from "react-router";
import {TablaTercero} from "./components/TablaTercero";
import {ModalNuevoTercero} from "./components/ModalNuevoTercero";
import {ModalEditarTercero} from "./components/ModalEditarTercero";

const TerceroPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);
    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }
    return (
        <div className="container-relative">
            {permisos.consultar
                ?
                <TablaTercero reload={resetLoad} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}/>
                :
                <Navigate to="/home"/>
            }
            <ModalNuevoTercero show={displayNewModal} hide={onHide}/>
            <ModalEditarTercero show={displayeditModal} hide={onHideEdit} fields={fieldEdit}/>
        </div>
    );
};

export default TerceroPage;